/**
 * IGNIERE §282 C-2′（2026-10-07 表示速度の改修）：ページの根（html）に「開いている物」の印を付ける。
 *
 * なぜ：CSS の `body:has(.ig-ab)`・`html:has(#cart-drawer[open])` のように**根に掛かる :has()** は、
 * ページのどこかが少し変わるたび（Shopify の読み込み処理・画像の自動サイズ・部品の起動）に根から
 * 全部のスタイルを計算し直させる。スマホ条件の実測で、この 15 規則だけで計算が 2,198ms → 381ms
 * （−83%）になった。そこで状態は JS がここ 1 か所で html の class に写し、CSS はその class を見る。
 *
 * 写す印（CSS 側の名前）：
 *   （ig-menu-open／ig-menu-opened＝Horizon の旧ドロワーの印は §401（2026-11-02）で外した。§326 の新しいドロワーは
 *     igniere-header-drawer が自分で開閉を持ち、html の印は使わない）
 *   ig-search-open   検索の窓（dialog-component.search-modal の dialog[open]）
 *   ig-cart-open     カートの引き出し（#cart-drawer[open]）
 *   ig-wishlist-open お気に入りの引き出し（#ig-wishlist-drawer[open]・§302）
 *   ig-filter-open   絞り込みのパネル（#MainContent .ig-filter-panel.open）
 *   ig-about-ondark  About の暗い面がヘッダーの下にある時（.ig-ab[data-ig-ondark]・igniere-about.js が付ける）
 *   ※ ig-about（About ページそのもの）は snippets/igniere-brand.liquid が Liquid で最初から付ける
 *
 * 仕組み：html 配下の open / class / data-ig-ondark の属性の変化を 1 つの MutationObserver で見て、
 * 変化のたびに 5 つの querySelector で状態を求め、違う時だけ class を付け外す（自分の変更では再計算しない）。
 */
(function () {
  'use strict';
  var H = document.documentElement;
  var STATES = [
    ['ig-search-open', 'dialog-component.search-modal dialog[open]'],
    ['ig-cart-open', '#cart-drawer[open]'],
    ['ig-wishlist-open', '#ig-wishlist-drawer[open]'],
    ['ig-filter-open', '#MainContent .ig-filter-panel.open'],
    ['ig-about-ondark', '.ig-ab[data-ig-ondark]']
  ];
  var queued = false;
  function sync() {
    queued = false;
    for (var i = 0; i < STATES.length; i++) {
      var on = !!document.querySelector(STATES[i][1]);
      if (H.classList.contains(STATES[i][0]) !== on) H.classList.toggle(STATES[i][0], on);
    }
  }
  function schedule() { if (!queued) { queued = true; Promise.resolve().then(sync); } }
  new MutationObserver(schedule).observe(H, { subtree: true, attributes: true, attributeFilter: ['open', 'class', 'data-ig-ondark'] });
  sync();
})();
